import { SmsMessageStatus } from "./sms-message-status.model";

export class SmsMessage {
  SmsMessageId: number;
  Sender: string;
  RecipientPhonenumber: string;
  Content: string;
  CreatedAt: Date;
  SentAt: Date;
  Status: SmsMessageStatus;
  HasError: boolean;
  ErrorMessage: string;

  constructor() {
    this.SmsMessageId = null;
    this.Sender = null;
    this.RecipientPhonenumber = null;
    this.Content = null;
    this.CreatedAt = null;
    this.SentAt = null;
    this.HasError = false;
    this.ErrorMessage = null;
  }
}

export let SmsMessageIgnoreList: any[] = [
  "SmsMessageStatus"
];
